import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../assests/css/students/FeeCards.css';
import { Calendar, FileText, Database, Bell } from 'lucide-react';

const FeeCards = () => {
  const [activeCard, setActiveCard] = useState(null);
  const navigate = useNavigate();

  const cards = [
    {
      id: 1,
      title: "Download Fee Challan",
      description: "Students can download their fee challan securely and easily ",
      icon: <Calendar size={52} />,
      path: "/download-fee-challan"
    },
    {
      id: 2,
      title: "Upload Receipt",
      description: "Students can upload their fee payment receipts securely and easily",
      icon: <FileText size={52} />,
      path: "/upload-receipt"
    },
    {
      id: 3,
      title: "Student Fee Record",
      description: "Maintain student fee payment history",
      icon: <Database size={52} />,
      path: "/view-records"
    },
    {
      id: 4,
      title: "Notification System",
      description: "Send automated notifications for fee dues ",
      icon: <Bell size={52} />,
      path: "/send-notifications"
    }
  ];

  const handleCardClick = (cardId, path) => {
    setActiveCard(cardId);
    navigate(path);
  };

  return (
    <div className="fee-container">
      <div className="fee-header">
        <h1>Our Fee Structure</h1>
        <p>Easy fee management for uploading, downloading, and submitting fee challans and receipts.
</p>
      </div>

      <div className="fee-cards-wrapper">
        <div className="fee-cards-row">
          {cards.map((card) => (
            <div
              key={card.id}
              className={`fee-card ${activeCard === card.id ? 'active' : ''}`}
              onClick={() => handleCardClick(card.id, card.path)}
            >
              <div className="fee-card-icon">{card.icon}</div>
              <h3 className="fee-card-title">{card.title}</h3>
              <p className="fee-card-description">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeeCards;